import { FormControlList } from './../../../../modules/shared/constants/formcontrol-list.constants';
import { ParseHelper } from './../../../../modules/shared/parse.helper';
import { SharedCRMConfigService } from './../../../../configurations/crm/shared/services/shared-crm-config.service';
import { Fields, SectionN } from './../../../../modules/shared/models/column-settings.model';
import { SharedColumnSettingsService } from './../../../../modules/shared/services/column-settings.service';
import { PermissionService } from './../../../../service/permission.service';
import { SharedChannelService } from './../../../../modules/shared/services/channel.service';
import { ObjectNames } from './../../../../modules/shared/constants/object.names';
import { AccountModuleId, CaseModuleId, LeadModuleId, OpportunityModuleId } from './../../../../modules/shared/constants/modules.constant';
import { DynamicTableCreateWidgetM } from './../../../../modules/shared/models/dynamic-table/dynamic-table-create-widget.model';
import { AppMainService } from './../../../../app-main.service';
import { DynamicTableWidgetService } from './../../../../modules/shared/services/dynamic-table/dynamic-table-widget.service';
import { DynamicTableWidgetTypesM } from './../../../../modules/shared/models/dynamic-table/dynamic-table-widget-types.model';
import { FormErrorHandler } from './../../../../modules/shared/helpers/form-error-handler.helper';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { MessageService } from 'primeng/api';
import { SavedSearchNS } from '../../models/saved-search.models';
import { SavedSearchesService } from '../../services/saved-searches.service';
import { DynamicTableWidgetDetailsM } from '../../../../modules/shared/models/dynamic-table/dynamic-table-widget-details.model';
import { ColumnDefinition } from 'src/app/modules/shared/models/dynamic-table/dynamic-table-data.model';
import { DynamicTableService } from 'src/app/modules/shared/services/dynamic-table/dynamic-table.service';
import { WorkbookList } from 'src/app/misc/workspace/models/workspace.models';

@Component({
    selector: 'app-add-to-list',
    templateUrl: './add-to-list.component.html',
    styleUrl: './add-to-list.component.scss'
})
export class AddToListComponent implements OnInit, OnDestroy {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    @Input() displayAddToList: boolean = false;
    @Input() savedSearchId: number;
    @Input() savedSearchModuleId: number;
    @Input() savedSearchTemplateId: number;
    @Input() selectedWorkbook: WorkbookList;
    @Input() selectedWidget: DynamicTableWidgetDetailsM;
    @Output() listAdded = new EventEmitter<boolean>();
    @Output() dialogClosed = new EventEmitter<boolean>();

    headerTitle: string = "Add To List";

    //Workflow details form
    addToListForm: FormGroup = new FormGroup({});
    isUnsavedData: boolean = false;
    detailsFormErrors: any = {};
    formErrorHandler: FormErrorHandler = new FormErrorHandler();
    submitLoading: boolean = false;

    parentModules: SavedSearchNS.IObjectType[] = [];
    parentTemplates: SavedSearchNS.ITemplate[] = [];
    savedSearchColumnList: any[] = [];
    moduleColumnList: any[] = [];
    savedSearchColumns: any[] = [];
    moduleColumns: any[] = [];
    widgetTypes: DynamicTableWidgetTypesM[] = [];
    //**Dynamic table variables */
    workbookColumns: ColumnDefinition[] = [];
    mapableControls :string[] = [
        FormControlList.InputBox,
        FormControlList.DropDownList,
        FormControlList.MultipleDropDownList,
        FormControlList.CheckBox,
        FormControlList.RadioButton,
        FormControlList.Rating,
        FormControlList.ToggleButton,
        FormControlList.Phone,
        FormControlList.Number,
        FormControlList.Email,
    ];

    constructor(
        private formBuilder: FormBuilder,
        private messageService: MessageService,
        private appMainService: AppMainService,
        private sharedChannelService: SharedChannelService,
        private savedSearchesService: SavedSearchesService,
        private permissionService: PermissionService,
        private sharedConfigService: SharedCRMConfigService,
        private dynamicTableWidgetService: DynamicTableWidgetService,
        private sharedColumnSettingsService: SharedColumnSettingsService,
        private readonly dynamicTableService: DynamicTableService,
    ) { }

    ngOnInit(): void {
        if(this.selectedWidget){
            this.headerTitle = "Edit Added List";
        }

        this.getWidgetTypes();
        this.getModuleDetails();
        if(this.savedSearchId){
            this.getSavedSearchColumnSettings();
        }
        else if(this.selectedWorkbook){
           this.getWorkbookColumn(this.selectedWorkbook?.id);
        }
        this.initAddToListForm();
        this.addToListForm.get('moduleField')?.value || this.selectedWidget?.referenceFieldId? this.addToListForm.get('referenceFieldId')?.enable() : this.addToListForm.get('referenceFieldId')?.disable();
    }

    initAddToListForm() {
        this.detailsFormErrors = {};
        this.isUnsavedData = false;
        this.addToListForm = this.formBuilder.group({
            id: [this.selectedWidget?.widgetId||0],
            widgetName: [this.selectedWidget?.widgetName||"", [Validators.required, Validators.maxLength(15)]],
            selectedModule: [this.selectedWidget?.moduleId||null, [Validators.required]],
            selectedChannel: [this.selectedWidget?.channelId||null, [Validators.required]],
            referenceFieldId: [this.selectedWidget?.referenceFieldId||null],
            moduleField: [null ],
            widgetType: [null, [Validators.required]]
        });

        if (this.savedSearchId) {
            this.addToListForm.get('referenceFieldId')?.setValidators([Validators.required]);
            this.addToListForm.get('moduleField')?.setValidators([Validators.required]);
        } else {
            this.addToListForm.get('referenceFieldId')?.clearValidators();
            this.addToListForm.get('moduleField')?.clearValidators();
        }

        // Update the validation status after changing validators
        this.addToListForm.get('referenceFieldId')?.updateValueAndValidity();
        this.addToListForm.get('moduleField')?.updateValueAndValidity();

        if (this.selectedWorkbook) {
            let isUpdating = false;
            this.addToListForm.get('moduleField')?.valueChanges
                .pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe(value => {
                    if (!isUpdating) {
                        isUpdating = true;
                        if (value) {
                            this.addToListForm.get('referenceFieldId')?.setValidators([Validators.required]);
                        } else {
                            this.addToListForm.get('referenceFieldId')?.clearValidators();
                        }
                        this.addToListForm.get('referenceFieldId')?.updateValueAndValidity();
                        isUpdating = false;
                    }
                });

            this.addToListForm.get('referenceFieldId')?.valueChanges
                .pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe(value => {
                    if (!isUpdating) {
                        isUpdating = true;
                        if (value) {
                            this.addToListForm.get('moduleField')?.setValidators([Validators.required]);
                        } else {
                            this.addToListForm.get('moduleField')?.clearValidators();
                        }
                        this.addToListForm.get('moduleField')?.updateValueAndValidity();
                        isUpdating = false;
                    }
                });
        }

        this.formErrorHandler.handleErrors(this.addToListForm, this.detailsFormErrors, {
            widgetName: {
                required: "Enter Sublist/Tab Name",
                maxLength: 'Enter less than 15 characters'
            },
            widgetType: {
                required: "Select Type"
            },
            selectedModule: {
                required: "Select Module"
            },
            selectedChannel: {
                required: "Select Channel"
            },
            referenceFieldId: {
                required: this.savedSearchId ? "Select Saved Search Field" : "Select Workbook Field"
            },
            moduleField: {
                required: "Select Module Field"
            }
        });

        this.addToListForm.valueChanges.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(e => this.isUnsavedData = true);

        if(this.selectedWidget?.moduleId){
            this.onChangeParentModule({value: this.selectedWidget?.moduleId}, false);
            this.getModuleFields({value: this.selectedWidget?.channelId}, this.selectedWidget?.moduleId);
        }
    }

    onNodeUnselect(event){
        this.addToListForm.get('moduleField')?.reset();
    }

    saveWidget() {
        if (this.addToListForm.invalid) {
            this.formErrorHandler.showErrorOnSubmit();
            this.scrollToError();
            return; //Return if form invalid
        }

        this.submitLoading = true;

        const formData = this.addToListForm.getRawValue();
        const widgetDetails: DynamicTableCreateWidgetM = {
            moduleId: formData.selectedModule,
            channelId: formData.selectedChannel,
            referenceFieldId: formData.referenceFieldId,
            associatedFieldId: formData?.moduleField?.id || null,
            referenceId: (this.savedSearchId ? this.savedSearchId : this.selectedWorkbook.intId) || null, //referenceId <->savesearchID
            widgetTypeId: formData.widgetType.id,
            widgetName: formData.widgetName,
            referenceType: this.savedSearchId ? 1 :2,  // For save search 2 for dynamic table
        }

        if(formData?.id){
            this.appMainService.isShowSpinner('saveWidget');
            this.dynamicTableWidgetService.updateWidget(widgetDetails, formData?.id).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
                next: (response) => {
                    this.submitLoading = false;
                    this.appMainService.isHideSpinner('saveWidget');
                    this.messageService.add({
                        severity: 'success',
                        summary: 'List Updated',
                        detail: "List Updated Successfully...",
                    });
                    this.listAdded.emit(true);
                    this.closeDialog();
                },
                error: (error) => {
                    this.submitLoading = false;
                    this.appMainService.isHideSpinner('saveWidget');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'List Update Failed',
                        detail: error?.error?.Message || "Error occurred while saving data...",
                    });
                }
            })
        }else{
            this.appMainService.isShowSpinner('saveWidget');
            this.dynamicTableWidgetService.createWidget(widgetDetails).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
                next: (response) => {
                    this.submitLoading = false;
                    this.appMainService.isHideSpinner('saveWidget');
                    this.messageService.add({
                        severity: 'success',
                        summary: 'List Added',
                        detail: "List Added Successfully...",
                    });
                    this.listAdded.emit(true);
                    this.closeDialog();
                },
                error: (error) => {
                    this.submitLoading = false;
                    this.appMainService.isHideSpinner('saveWidget');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Add to List Failed',
                        detail: error?.error?.Message || "Error occurred while saving data...",
                    });
                }
            })
        }

    }

    // Scroll to error handler function
    scrollToError(): void {
        const firstElementWithError = document.querySelector('.ng-invalid[formControlName]');
        this.scrollTo(firstElementWithError);

        if (!firstElementWithError) {
            const secondElementWithError = document.querySelector('.p-invalid');
            this.scrollTo(secondElementWithError);
        }
    }

    // Scroll to error element
    scrollTo(el: Element): void {
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    getWidgetTypes() {
        this.appMainService.isShowSpinner('getWidgetTypes');
        this.dynamicTableWidgetService.getWidgetTypes().pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response) => {
                this.widgetTypes = response || [];

                let selectedType: DynamicTableWidgetTypesM | null = this.widgetTypes?.[0] || null;
                if(this.selectedWidget){
                    selectedType = this.widgetTypes.find(w=> w.description==this.selectedWidget.widgetType)||null;
                }

                this.addToListForm.patchValue({
                    widgetType: selectedType
                });

                this.appMainService.isHideSpinner('getWidgetTypes');
            },
            error: (error) => {
                this.appMainService.isHideSpinner('getWidgetTypes');
            }
        })
    }

    getModuleDetails() {
        this.appMainService.isShowSpinner("loadModules");
        this.savedSearchesService.getAllModules('SavedSearchModule')
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (response) => {
                    this.appMainService.isHideSpinner("loadModules");
                    this.parentModules = response || [];
                    this.parentModules = this.parentModules.filter(m => [AccountModuleId, LeadModuleId , CaseModuleId , OpportunityModuleId].includes(m.objectId));
                },
                error: (error) => {
                    this.appMainService.isHideSpinner("loadModules");
                    this.messageService.add({
                        severity: 'error',
                        summary: 'error',
                        detail: "Error occurred...",
                    });
                }
            });
    }

    onChangeParentModule($event: any, clearValues: boolean = true) {
        const objectId: number = $event.value;

        if(clearValues){
            this.addToListForm.patchValue({
                selectedChannel: null,
                moduleField: null
            });
        }

        this.appMainService.isShowSpinner('getTemplateList');
        const isTrueForOpportunity  = objectId === OpportunityModuleId;
        this.sharedChannelService.getChannels(objectId, isTrueForOpportunity).subscribe({
            next: (response) => {
                this.appMainService.isHideSpinner('getTemplateList');
                let channels = response || [];

                switch (objectId) {
                    case AccountModuleId:
                        channels = this.permissionService.filterChannelsByPermissions(channels, ObjectNames.ACCOUNT);
                        break;
                    case LeadModuleId:
                        channels = this.permissionService.filterChannelsByPermissions(channels, ObjectNames.LEAD);
                        break;
                    case OpportunityModuleId:
                        channels = this.permissionService.filterChannelsByPermissions(channels, ObjectNames.OPPORTUNITY);
                        break;
                    default:
                        break;
                }

                const processedData = channels.map((obj) => {
                    return {
                        id: obj?.id,
                        templateName: obj?.name,
                        channelName: obj?.name,
                        channelId: obj?.id,
                        objectId: objectId
                    }
                });

                this.parentTemplates = processedData;
            },
            error: (error) => {
                this.appMainService.isHideSpinner('getTemplateList');
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.message ? error?.error?.message : 'Templates are not loaded, please try again...'
                });
            }
        });
    }

    getSavedSearchColumnSettings(): void {
        this.appMainService.isShowSpinner('getColumnSettings');
        this.sharedColumnSettingsService.getColumnSettingsForSavedSearch(this.savedSearchModuleId, this.savedSearchTemplateId, this.savedSearchId)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (response) => {

                    const savedSearchColumnSettings: SectionN[] = response?.listViewSections || [];
                    const enabledColumns: Fields[] = [];

                    savedSearchColumnSettings.map(f => {
                        f?.fields?.filter(f => f.enabled == true || f?.childFields?.length > 0)?.map(x => {
                            if (x?.childFields?.length > 0) {
                                x.childFields?.filter(n => n.enabled == true)?.map(nestObj => {
                                    enabledColumns.push(nestObj);
                                })
                            } else {
                                enabledColumns.push(x);
                            }
                        })
                    });

                    //this.savedSearchColumns = enabledColumns.filter(col=> ['String','Enum'].includes(col.fieldDataType));
                    this.savedSearchColumns = enabledColumns.filter(col => this.mapableControls.includes(col.formControlType));

                    this.appMainService.isHideSpinner('getColumnSettings');
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('getColumnSettings');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error?.error?.message ? error?.error?.Message : 'Column Settings are not loaded, please try again...'
                    });
                },
                complete: () => {

                },
            });
    }

    getModuleFields($event: any, moduleId: number = 0): void {
        const objectId: number = this.addToListForm.value.selectedModule||moduleId;
        const channelId: number = $event.value;

        this.addToListForm.patchValue({
            moduleField: null
        });

        this.appMainService.isShowSpinner('getTemplateFormFields');
        this.sharedConfigService
            .getTemplateFormFields(objectId, channelId)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (response) => {
                    this.moduleColumnList = response;
                    this.appMainService.isHideSpinner('getTemplateFormFields');
                    this.prepareFieldObjectAndTreeForAccLead();
                },
                error: () => {
                    this.appMainService.isHideSpinner('getTemplateFormFields');
                }
            });
    }

    prepareFieldObjectAndTreeForAccLead() {
        const selectableFields: any[] = [];
        const filterDDTree = this.moduleColumnList.map(item => {
            const fields = item.fields
              .filter(field => (field.enabledInForm === true && this.mapableControls.includes(field.formControl)))
              .map(field => {
                const childFields = field.childFields
                  .filter(childField => (childField.enabledInForm === true && this.mapableControls.includes(field.formControl)))
                  .map(childField => {
                    const custom = false;
                    const rField = {
                        label: childField.labelName,
                        labelname: childField?.labelName,
                        parentLabelName: field?.labelName||field?.name,
                        id: childField.id,
                        selectable: true,
                        customAttributeObjectId: childField?.customAttributeObjectId||null,
                        custom,
                        ...childField,
                        children: []
                    }

                    selectableFields.push({...rField,children: null});
                    return rField;
                  });

                const custom = false;
                const rField = {
                  label: field.labelName,
                  id: field.id,
                  labelname: field?.labelName,
                  customAttributeObjectId: field?.customAttributeObjectId||null,
                  custom,
                  selectable: childFields.length === 0,
                  ...field,
                  children: childFields
                };

                rField?.selectable && selectableFields.push({...rField,children: null});
                return rField;
              });

            const customFields = item.customFields
              .filter(customField => (customField.enabledInForm === true && this.mapableControls.includes(customField?.formControl?.type)))
              .map(customField => {
                const custom = true;
                customField.custom = true;

                let custompickvalues: any[] = [];
                let typescustom = [];
                typescustom = customField?.formControl?.pickListValues||[];
                for (let l of typescustom) {
                    let name = l;
                    let eachType = {
                        id: name,
                        name: name,
                    }
                    custompickvalues.push(eachType);
                }

                const rField = {
                    label: customField.labelName,
                    id: customField.id,
                    labelname: customField?.labelName,
                    selectable: true,
                    custom,
                    formControl: customField.formControl.type,
                    formControlId: customField.formControl.id,
                    customAttributeObjectId: customField?.customAttributeObjectId||null,
                    pickListValues: JSON.stringify(custompickvalues),
                    ...customField,
                    children: []
                }

                selectableFields.push({...rField,children: null});
                return rField;
              });

            const sortedChildren = [...fields, ...customFields];
            sortedChildren.sort((a, b) => a.label.localeCompare(b.label));


            return {
              label: item.name,
              id: item?.id,
              selectable: false,
              children: sortedChildren
            };
        });

        this.moduleColumns = ParseHelper.DeepCopy(filterDDTree);
        this.moduleColumns = this.moduleColumns.filter(section=> section.children?.length>0);

        if(this.selectedWidget?.associationFieldId){
            const selectedModuleField = selectableFields.find(field=> field.id===this.selectedWidget.associationFieldId);
            this.addToListForm.patchValue({
                moduleField: selectedModuleField
            });
        }
    }

    onFieldChangeRuleList(event: any) {
        this.addToListForm.controls['referenceFieldId'].patchValue(null)
        const moduleColumnDataType:string=event.node?.formControl?.type ? event.node.formControl.type : event.node.formControl
        moduleColumnDataType ? this.addToListForm.controls['referenceFieldId'].enable() : this.addToListForm.controls['referenceFieldId'].disable()
    }

    closeDialog() {
        this.dialogClosed.emit();
    }

    //** Workbook changes */

    getWorkbookColumn(workbookId:string) {
        this.appMainService.isShowSpinner('getWorkbookColumn');
        this.dynamicTableService.getDynamicTableColumn(workbookId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
          next: (response: ColumnDefinition[]) => {
            this.appMainService.isHideSpinner('getWorkbookColumn');
            this.workbookColumns = [...response];
            // this.workbookColumns = this.workbookColumns.filter(col=> ['String','Enum'].includes(col.dataType));
            this.workbookColumns = this.workbookColumns .filter(col => this.mapableControls.includes(col.formControlName));
          },
          error: (error) => {
            this.appMainService.isHideSpinner('getWorkbookColumn');
          }
        })
    }
      
    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

}
